import React, { useCallback } from 'react';

import BooksMenuItem from '../../../../../molecules/merchant/resources/book/BooksMenuItem';
import { Course } from '../../../../../interfaces/merchants/resources/books';

interface Props {
  courses: Course[];
  postable: boolean;
  onClick: (course: Course) => void;
}

const InputBookingTargetCourseSelector: React.FC<Props> = ({
  courses,
  postable,
  onClick,
}) => {
  const handleClickCourse = useCallback(
    (e: React.MouseEvent<HTMLInputElement>) => {
      const course = courses.find(
        (c) => String(c.id) === e.currentTarget.value,
      )!;
      onClick(course);
    },
    [courses, onClick],
  );

  return (
    <div>
      {courses.map((course) => (
        <BooksMenuItem
          key={course.id}
          courseName={course.name}
          image={course.image}
          price={course.price}
          duration={course.duration}
          // @ts-expect-error strictFunctionTypes
          onClick={handleClickCourse}
          postable={postable}
          text={course.description}
          value={course.id}
        />
      ))}
    </div>
  );
};

export default InputBookingTargetCourseSelector;
